import { render, staticRenderFns } from "./ImagesTemplate.vue?vue&type=template&id=01d8160e&scoped=true&"
import script from "./ImagesTemplate.vue?vue&type=script&lang=ts&"
export * from "./ImagesTemplate.vue?vue&type=script&lang=ts&"
import style0 from "./ImagesTemplate.vue?vue&type=style&index=0&id=01d8160e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01d8160e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})


/* vuetify-loader */
import installDirectives from "!../../../node_modules/vuetify-loader/lib/runtime/installDirectives.js"
import ClickOutside from 'vuetify/lib/directives/click-outside'
installDirectives(component, {ClickOutside})
